import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TokenStorageService } from '../../services/storage/token-storage.service';

@Component({
    selector: 'app-dashboard-layout',
    templateUrl: './dashboard-layout.component.html',
    styleUrls: ['./dashboard-layout.component.css'],
    standalone: false
})
export class DashboardLayoutComponent implements OnInit {
  activePage = '';
  user: any;
  isLoggedIn: boolean = false;
  toggle: boolean = false;
  showAdminComponents: boolean = false;
  showBrokerComponents: boolean = false;
  showBrokerAdminComponents: boolean = false;
  showInternalUserComponents: boolean = false;
  showSysAdminComponents: boolean = false;
  isAllowedUrlIssuerRole: boolean = false;

  tog: any;

  avatarColor: string = ''; // Avatar background color

  isSidebarOpen = false;

  activeMenuTitle: string = 'User Profile';
  activeMenuIcon: string = 'fa-regular fa-user';

  setActiveMenu(title: string, icon: string) {
    this.activeMenuTitle = title;
    this.activeMenuIcon = icon;
  }

  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar(): void {
    this.isSidebarOpen = false;
  }

  closeSidebarOnMobile(): void {
    if (window.innerWidth < 768) {
      this.closeSidebar();
    }
  }

  constructor(
    private router: Router,
    private tokenStorageService: TokenStorageService,
  ) {}

  ngOnInit(): void {
    this.activePage = this.router.url.split('/')[2];
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    const allowedUrlIssuerRoles = [
      'appUrlIssuerDev',
      'appUrlIssuerQA',
      'appUrlIssuerSandbox',
      'appUrlIssuerAsiaUAT',
      'appUrlIssuerMenaUAT',
      'appUrlIssuerEuropeUAT',
      'appUrlIssuerUSUAT',
      'appUrlIssuerAsiaPROD',
      'appUrlIssuerMenaPROD',
      'appUrlIssuerEuropePROD',
      'appUrlIssuerUSPROD',
    ];

    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();

      this.showAdminComponents = this.user.role === 'admin';
      this.showBrokerComponents = this.user.role === 'broker';
      this.showBrokerAdminComponents = this.user.role === 'brokerAdmin';
      this.showInternalUserComponents = this.user.role === 'internalUser';
      this.showSysAdminComponents = this.user.role === 'sysAdmin';
      this.isAllowedUrlIssuerRole = this.user.secondaryRole.some(
        (role: string) => allowedUrlIssuerRoles.includes(role),
      );

      // Generate avatar color based on the username
      this.avatarColor = this.getAvatarColor(this.user.username);
    }

    this.toggle =
      JSON.parse(localStorage.getItem('initialLoginFlagV2') || '{}') === 1;
  }

  // Method to get initials from the username
  getInitials(username: string): string {
    if (!username) return '';
    const initials = username
      .split(' ')
      .map((name) => name[0])
      .join('');
    return initials.length > 2
      ? initials.slice(0, 2).toUpperCase()
      : initials.toUpperCase();
  }

  // Method to generate a random (or deterministic) color for the avatar
  getAvatarColor(username: string): string {
    const colors = ['#ff7675', '#55efc4', '#74b9ff', '#a29bfe', '#74b9ff'];
    if (!username) return colors[0];
    const charIndex = username.charCodeAt(0) % colors.length;
    return colors[charIndex];
  }
}
